'use client'; // <-- Самая важная строка! Она делает этот компонент клиентским.

import dynamic from 'next/dynamic';

// Здесь мы делаем тот же самый динамический импорт, но уже внутри клиентского компонента
const Breadcrumbs = dynamic(() => import('./Breadcrumbs'), {
  ssr: false,
});

// Этот компонент просто возвращает лениво загруженные "хлебные крошки"
export function BreadcrumbsDynamic() {
  return <Breadcrumbs />;
}
